import emailAddress from 'email-validator';
import postalCodes from 'postal-codes-js';
import password from 'password-validator';
import moment from 'moment';
import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

export const isDateValid = (
    date: moment.Moment | null,
    otherChecks = {
        afterTodayCheck: false,
        beforeTodayCheck: false,
        beforeDateCheck: moment().add(10, 'years'),
        afterDateCheck: moment().subtract(100, 'years')
    }
): boolean => {
    if (
        !date
        || !date.isValid()
        || (otherChecks.afterTodayCheck && !date.isAfter(moment()))
        || (otherChecks.beforeTodayCheck && !date.isBefore(moment()))
        || !date.isBefore(otherChecks.beforeDateCheck)
        || !date.isAfter(otherChecks.afterDateCheck)
    ) {
        return false;
    }
    return true;
};

export const isEmailValid = (email: string | null): boolean => {
    if (!email) return false;
    return emailAddress.validate(email);
};

export const isPhoneValid = (phone: any | null): boolean => {
    if (!phone) return false;
    try {
        const number = phoneUtil.parseAndKeepRawInput(phone, 'US');
        return phoneUtil.isValidNumber(number);
    } catch (err) {
        return false;
    }
};

export const isZipValid = (zip: string | null): string | boolean => {
    if (!zip) return false;
    return postalCodes.validate('USA', zip);
};

export const isNameValid = (name: any | null): boolean => {
    if (!name) return false;
    const nameReg = /^[a-z ,.'-]+$/i;
    return nameReg.test(name) && name.match(nameReg)[0].length > 1;
};

export const isAddressValid = (address: string | null): boolean => {
    if (!address) return false;
    const addressReg = /\d+[ ](?:[A-Za-z0-9.-]+[ ]?)+(?:\w)\.?/g;
    return addressReg.test(address);
};

export const isCityValid = (city: string | null): boolean => {
    if (!city) return false;
    const cityReg = /^([a-zA-Z\u0080-\u024F]+(?:. |-| |'))*[a-zA-Z\u0080-\u024F]*$/g;
    return cityReg.test(city);
};

export const isPasswordValid = (pw: string | null): boolean => {
    if (!pw) return false;
    // eslint-disable-nest-line new-cap
    const pass = new password();

    pass.is()
        .min(8)
        .has()
        .uppercase()
        .has()
        .lowercase()
        .has()
        .digits(1)
        .has()
        .symbols(1)
        .is()
        .not()
        .oneOf(['password', 'abc123']);

    return pass.validate(pw) as boolean;
};
